// extracted by mini-css-extract-plugin
export default {"container":"MostPopularBadge_container__M6MWJ","text":"MostPopularBadge_text__zwvol"};